import React from "react";
import {
    Row,
    Col,
  } from "reactstrap";
import Bounce from 'react-reveal/Bounce';
import {Helmet} from "react-helmet";
  
// reactstrap components
import "./button.css";
// core components
import { useTranslation } from 'react-i18next';

const lngs = {
  en: { nativeName: 'English' },
  es: { nativeName: 'Spanish' }
};
function Buttons() {
  const { t, i18n } = useTranslation();


  return (
    <>
  
    <br/>
    <br/>
    <br/>
    <br/>
  
    <div >

    <br/>
    <Helmet>
    <div class="container">
  <nav>
    <ul><Row><Col sm='8' md="8">
    {/* <b>{t('description.part27')}</b><br/> */}
    <b>
    {t('description.part6')}</b><br/>
    <Row><Col sm='4' md='4'><a href="mailto:btcartagenaonline@gmail.com" target="_blank"><Bounce><b><u>btcartagenaonline@gmail.com</u></b></Bounce></a></Col><Col sm='8' md="8"><div class='box'>
    <span class="h3" href="tel:573006572717"><b> (+57) 210-983-1340&nbsp; </b></span></div><div class='box2'>
    <a href="tel:573006572717"><p><b>(+57) 300-657-2717&nbsp; </b></p></a></div></Col></Row></Col><Col sm='4' md="4"> 
{Object.keys(lngs).map((lng) => (
            <button class="li" role="button" key={lng} style={{ background: 'orange', fontWeight: i18n.resolvedLanguage === lng ? 'bold' : 'normal' }} type="submit" onClick={() => i18n.changeLanguage(lng)}>
              {lngs[lng].nativeName}
            </button>
          ))}</Col>
          </Row></ul>
  </nav>
</div>
<meta name="description" content="Sport boats and yacht rentals. Alquiler de botes deportivos y yates"/>
   </Helmet>
   <div class="container">
  <nav>
    <ul><Row><Col sm='8' md="8">
    {/* <b>{t('description.part27')}</b><br/> */}
    <b>
    {t('description.part6')}</b><br/>
    <Row><Col sm='4' md='4'><a href="mailto:btcartagenaonline@gmail.com" target="_blank"><Bounce><b><u>btcartagenaonline@gmail.com</u></b></Bounce></a></Col><Col sm='8' md="8"><div class='box'>
    <span class="h3" href="tel:573006572717"><b> (+57) 300-657-2717&nbsp; </b></span></div><div class='box2'>
    <a href="tel:573006572717"><p><b>(+57) 300-657-2717&nbsp; </b></p></a></div></Col></Row></Col><Col sm='4' md="4"> 
{Object.keys(lngs).map((lng) => (
            <button class="li" role="button" key={lng} style={{ background: 'orange', fontWeight: i18n.resolvedLanguage === lng ? 'bold' : 'normal' }} type="submit" onClick={() => i18n.changeLanguage(lng)}>
              {lngs[lng].nativeName}
            </button>
          ))}</Col>
          </Row></ul>
  </nav>
</div>
        </div>
    </>
  );
}

export default Buttons;
